import React, { useEffect } from 'react';
import { useState } from 'react';
import { IBroker } from '../../modals/Broker.modal';
import brokerService from '../../services/broker.service';
import { useNavigate } from 'react-router-dom';
import kcService from '../../services/kc.service';

function Broker() {
    const navigate = useNavigate();
    const [brokers, setBrokers] = useState<IBroker[] | any>([]);

    useEffect(() => {
        brokerService.getAllBrokers().then((response) => {
            console.log('Brokers:', response.data.data);
            
            return setBrokers(response.data.data);
        }).catch((error) => {
            console.log('Error fetching brokers:', error);
            // setBrokers([]);
        });
    }, []);

    const navigateToAdd = (() => {
        navigate(`/broker/add`)
    });

    return (
        <div className="container mt-2">
            <div className="d-flex justify-content-between align-items-center">
                <h2 className='titleColor'>Brokers</h2>
                <button type="button" className='btn btn-sm btn-outline-primary' onClick={navigateToAdd} >Add Broker</button>
            </div>
            

            <div className="row">
                {brokers?.map((broker: IBroker, i: number) => (
                    <div key={`broker?.id-${i}`} className="col-sm-6 col-md-6 col-lg-4 mb-3">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">{broker?.name}</h5>
                                <p className="card-text">
                                    <strong>Register Date:</strong> {new Date(broker?.createdDate).toLocaleDateString()}
                                    <br />
                                    <strong>Verified:</strong> {broker?.isVerified ? 'Yes' : 'No'}
                                </p>
                                <button onClick={() => {
                                    kcService.getLoginUrl().then((response) => {
                                        console.log('Login URL:', response.data.data);
                                        window.location.href = response.data.data;
                                    }).catch((error) => {
                                        console.error('Error fetching login URL:', error);
                                        alert('Failed to get login URL. Please try again later.');
                                    })
                                }} className="btn btn-primary">Get Token</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Broker;